import { render, staticRenderFns } from "./MainBody.vue?vue&type=template&id=d5453ada&scoped=true"
import script from "./MainBody.vue?vue&type=script&lang=js"
export * from "./MainBody.vue?vue&type=script&lang=js"
import style0 from "./MainBody.vue?vue&type=style&index=0&id=d5453ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5453ada",
  null
  
)

export default component.exports